import styled from '@emotion/styled';

export const MessageWrapper = styled('div')`
  color: ${(props) => props.theme.colors.highEmphasis};
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;
  overflow-y: auto;
  width: 100%;
`;

export const ButtonWrapper = styled('div')`
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: 2;
`;

export const Button = styled('button')`
  height: 32px;
  color: ${(props) => props.theme.colors.mediumEmphasis};
  background-color: transparent;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: transparent;
    outline: none;
  }
`;
